import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=a1f03982&scoped=true&"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js&"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f03982",
  null
  
)

export default component.exports